import React, { useState } from 'react';
import JobSubjectNoteTable from '../components/JobSubjectNoteTable';
import JobSubjectNoteDetailPage from './JobSubjectNoteDetailPage';
import DefaultModal from 'components/Modal/DefaultModal';
import Button from 'components/Button/Button';

const JobSubjectNotePage = () => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);

    const toggleModal = () => {
        setShowModal((prevState) => !prevState);
    };

    const openModal = (isEdit: boolean) => {
        setIsEdit(isEdit);
        setShowModal(true);
    };

    return (
        <div className="p-2 md:p-10 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
            <div className="flex justify-items-center">
                <h1 className="text-lg leading-10 grow font-medium truncate mr-5 dark:text-gray-300">
                    Job Subject Notes
                </h1>
                <div className="">
                    <Button
                        title="New Job Subject Note"
                        onClick={() => openModal(false)}
                    />
                </div>
            </div>
            <div className="mt-3">
                <JobSubjectNoteTable openModal={openModal} />

                <DefaultModal
                    title="Job Subject Note"
                    show={showModal}
                    onClose={toggleModal}
                    body={
                        <JobSubjectNoteDetailPage
                            isEdit={isEdit}
                            toggleModal={toggleModal}
                        />
                    }
                />
            </div>
        </div>
    );
};

export default JobSubjectNotePage;
